/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_StepsInputs */

const en_fc_dl_steps = /** @type {(inputs: Fc_Dl_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to install`)
};

/**
* | output |
* | --- |
* | "How to install" |
*
* @param {Fc_Dl_StepsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_steps = /** @type {((inputs?: Fc_Dl_StepsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_StepsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_steps(inputs)
});
export { fc_dl_steps as "fc.dl.steps" }